import '../Profile.scss';

import React from 'react';
import { connect } from "react-redux";
import { routerActions } from "react-router-redux";

import { renderSpecializationString } from 'utils/utils';

import { getUserById } from 'containers/Accounts/store/actions';
import { clearMessage, postConversation, setMessage } from 'containers/Messaging/store/actions';

import A from 'components/A';
import Avatar from 'components/Avatar';
import Button from 'components/Button';
import CircleIcon from 'components/CircleIcon';
import H1 from 'components/H1';
import H2 from 'components/H2';
import H3 from 'components/H3';
import Icon from 'components/Icon';
import LoadingCircle from 'components/LoadingCircle';
import MessageModal from 'components/Modal/MessageModal';
import PageContent from 'components/PageContent';
import Pill from 'components/Pill';

class Freelancer extends React.Component {
    constructor() {
        super();

        this.socialLinks = [{
            icon: 'linkedin',
            selector: 'linkedIn',
            urlBase: 'https://linkedin.com/'
        }, {
            icon: 'dribbble',
            selector: 'dribbble',
            urlBase: 'https://dribbble.com/'
        }, {
            icon: 'twitter',
            selector: 'twitter',
            urlBase: 'https://twitter.com/'
        }, {
            icon: 'facebook',
            selector: 'facebook',
            urlBase: 'https://facebook.com/'
        }, {
            icon: 'instagram',
            selector: 'instagram',
            urlBase: 'https://instagram.com/'
        }, {
            icon: 'github',
            selector: 'github',
            urlBase: 'https://github.com/'
        }];
    }

    componentWillMount() {
        document.body.classList.add('profile-page');
        document.body.classList.add('freelancer-page');

        if(window.location.pathname !== '/freelancer/preview') {
            this.props.getUserById(this.props.params.id)
                .then((res) => {
                    if (res.data.data.isFreelancer !== true) {
                        this.props.changeLocation('/account/profile');
                    }
                });
        }
    }

    componentWillUnmount() {
        document.body.classList.remove('profile-page');
        document.body.classList.remove('freelancer-page');
    }

    render() {
        let { user } = this.props.accounts;

        if(this.props.accounts.isFetching === true || Object.keys(user).length === 0) {
            return (
                <PageContent className="profile freelancer">
                    <LoadingCircle />
                </PageContent>
            );
        } else {
            return (
                <PageContent className="profile freelancer">
                    <section className="profile__column profile__column--left">
                        <Avatar imageUrl={user.profilePicUrl} size="large"/>

                        <header className="profile__header">
                            <H2 className="profile__role">
                                {renderSpecializationString(user)}
                            </H2>

                            <H1 className="profile__name">
                                {`${user.firstName} ${user.lastName}`}
                            </H1>

                            <div className="profile__details">
                                <div className="profile__experience">
                                    {user.experienceYears} yrs. experience
                                </div>
                                <div className="profile__location">
                                    <Icon type="location"/>
                                    {user.location && user.location.text ? user.location.text : 'Remote'}
                                </div>
                            </div>
                        </header>

                        <div className="profile__actions">
                            <Button className="profile__action"
                                    noStyles
                                    onClick={() => this.messageModal.showMessageModal()}>
                                <CircleIcon type="email"/>
                                Message {user.firstName}
                            </Button>

                            {/*<Button className="profile__action"
                                    noStyles
                                    onClick={() => alert('Favorite this freelancer')}>
                                <CircleIcon type="heart"/>
                                Favorite
                            </Button>*/}
                        </div>

                        <div className="profile__contact">
                            {user.website != null ? (
                                <React.Fragment>
                                    {user.website.replace(' ', '').split(',').map((link) => (
                                        <div>
                                            <A href={link.indexOf('http') !== 0 ? `http://${link}` : link}>{link}</A>
                                        </div>
                                    ))}
                                </React.Fragment>
                            ) : null}
                            {user.phoneNumber != null ? (
                                <div>
                                    {user.phoneNumber}
                                </div>
                            ) : null}
                            <div>
                                <A href={`mailto:${user.email}`}
                                   target="_blank">
                                    {user.email}
                                </A>
                            </div>
                        </div>

                        {user.linkedIn != null || user.dribbble != null || user.twitter != null || user.facebook != null || user.instagram != null || user.github != null ? (
                            <div className="profile__social-links">
                                {this.socialLinks.map((link) => {
                                    if (user[link.selector] != null) {
                                        return (
                                            <A href={`https://${user[link.selector]}`}
                                               className={`profile__social-link profile__social-link--${link.icon}`}>
                                                <Icon type={link.icon}/>
                                            </A>
                                        );
                                    } else {
                                        return null;
                                    }
                                })}
                            </div>
                        ) : null}
                    </section>

                    <section className="profile__column profile__column--right">
                        <header className="profile__header">
                            <H2 className="profile__role">
                                {renderSpecializationString(user)}
                            </H2>

                            <H1 className="profile__name">
                                {`${user.firstName} ${user.lastName}`}
                            </H1>

                            <div className="profile__details">
                                <div className="profile__experience">
                                    {user.experienceYears} yrs. experience
                                </div>
                                <div className="profile__location">
                                    <Icon type="location"/>
                                    {user.location && user.location.text ? user.location.text : 'Remote'}
                                </div>
                            </div>
                        </header>

                        <div className="profile__bio">
                            <div className="profile__about profile__bio-section">
                                <H3 className="profile__subtitle">
                                    About Me
                                </H3>
                                <div className="profile__about-text">
                                    {user.description && user.description.split(/\n/).map((paragraph) => {
                                        if(paragraph) {
                                            return <p>{paragraph}</p>;
                                        } else {
                                            return null;
                                        }
                                    })}
                                </div>
                            </div>

                            {/*<div className="profile__skills profile__bio-section">
                                <H3 className="profile__subtitle">
                                    Skills
                                </H3>
                                <ul className="profile__skills-list">
                                    {this.skills.map((skill) => {
                                        return (
                                            <Pill
                                                className="profile__skill profile__pill"
                                                content={skill}
                                            />
                                        );
                                    })}
                                </ul>
                            </div>*/}

                            {user.industryExperiences != null && user.industryExperiences.length > 0 ? (
                                <div className="profile__industry-experiences profile__bio-section">
                                    <H3 className="profile__subtitle">
                                        Industry Experience
                                    </H3>
                                    <ul className="profile__industry-experiences-list profile__pill-list">
                                        {user.industryExperiences.map((ie) => {
                                            return (
                                                <Pill
                                                    className="profile__industry-experience profile__pill"
                                                    content={ie.name}
                                                />
                                            );
                                        })}
                                    </ul>
                                </div>
                            ) : null}

                            {user.brandExperience != null && user.brandExperience !== '' ? (
                                <div className="profile__brand-experiences profile__bio-section">
                                    <H3 className="profile__subtitle">
                                        Brand Experience
                                    </H3>
                                    <ul className="profile__brand-experiences-list">
                                        {user.brandExperience.split(',').map((be) => {
                                            if(be != null && be !== '' && be !== ' ') {
                                                return (
                                                    <li className="profile__brand-experience">
                                                        {be}
                                                    </li>
                                                );
                                            } else {
                                                return null;
                                            }
                                        })}
                                    </ul>
                                </div>
                            ) : null}
                        </div>
                    </section>

                    <MessageModal
                        onRef={ref => (this.messageModal = ref)}
                    />
                </PageContent>
            );
        }
    }
}

const mapStateToProps = (state) => {
    return {
        accounts: state.accounts,
        auth: state.auth,
        messaging: state.messaging
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeLocation: (path) => dispatch(routerActions.push(path)),
        clearMessage: () => dispatch(clearMessage()),
        getUserById: (userId) => dispatch(getUserById(userId)),
        postConversation: () => dispatch(postConversation()),
        setMessage: (message) => dispatch(setMessage(message))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Freelancer);



// WEBPACK FOOTER //
// ./src/containers/Accounts/Profile/Freelancer/index.js